const filterRenderFormats = {
  is_discounted: 'boolean',
  filter: 'filters',
  per: 'number',
};

export default filterRenderFormats;
